import { i18n } from '../../i18n/translate';

export const homeroomStudentNavigation = (environment = { MENU_DOMAIN_FOR_HOMEROOM: '' }) => {
  const { MENU_DOMAIN_FOR_HOMEROOM, MENU_DOMAIN_FOR_FRONT_END } = environment;
  return {
    id: 'foundry--universal_navigation--menus--homeroom_student_navigation',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--homeroom_student_navigation',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    weight: 100,
    submenu_items: [
      {
        id: 'help-menu-button',
        slug: '',
        title: i18n.t('Help'),
        icon: 'circle-question',
        font_family: '',
        css_class: '',
        target_url: 'help_modal',
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: 'language-menu-button',
        title: i18n.t('Language'),
        icon: 'language',
        target_url: 'language_modal',
        weight: 100,
        new_window: false,
        slug: '',
        submenu_items: [],
      },
      {
        id: '',
        slug: '',
        title: '{{user_name}}',
        icon: 'circle-user',
        font_family: '',
        css_class: 'account',
        target_url: '',
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [
          {
            id: 'my_profile',
            slug: '',
            title: i18n.t('My Profile'),
            icon: 'circle-user',
            font_family: '',
            css_class: '',
            module: 'adminifi',
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/k12student/my_profile`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: 'logout',
            slug: 'logout',
            title: i18n.t('Logout'),
            icon: 'power-off',
            font_family: '',
            css_class: '',
            module: 'adminifi',
            target_url: `${MENU_DOMAIN_FOR_HOMEROOM}/registration/logout`,
            target_method: 'GET',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: '',
            icon: '',
            font_family: '',
            css_class: '',
            target_url: '',
            target_method: '',
            new_window: false,
            subsection: true,
            weight: 99,
            submenu_items: [
              {
                id: '',
                slug: '',
                title: i18n.t('Privacy Policy'),
                icon: 'file-shield',
                font_family: '',
                css_class: '',
                data_attribute: 'privacy-policy-link',
                privacy_processing: 'policy',
                target_url: '',
                target_method: '',
                new_window: true,
                subsection: false,
                submenu_items: [],
                weight: 100,
              },
              {
                id: '',
                slug: '',
                title: i18n.t('Privacy Choices'),
                icon: 'ballot-check',
                font_family: '',
                css_class: '',
                data_attribute: 'privacy-choices-link',
                privacy_processing: 'choices',
                target_url: '',
                target_method: '',
                new_window: true,
                subsection: false,
                submenu_items: [],
                weight: 100,
              },
              {
                id: '',
                slug: '',
                title: i18n.t('Terms of Service'),
                icon: 'shield-check',
                font_family: '',
                css_class: '',
                target_url: 'https://everfi.com/terms-of-service',
                target_method: '',
                new_window: true,
                subsection: false,
                submenu_items: [],
                weight: 100,
              },
            ],
          },
        ],
      },
    ],
  };
};
